import { ClockPickerView } from "@mui/x-date-pickers";
import { useRecoilValue } from "recoil";
import dayjs from "dayjs";
import {useCallback, useContext, useEffect, useMemo} from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormDateTimePicker } from "../../../../../../components/fields";
import useDebounceCallback from "../../../../../../hooks/useDebouncedCallback";
import { RentalLocationType } from "../../../../../../types";
import { shouldDisableRentalDate, shouldDisableRentalTime } from "../../../../../../utils";
import { IFormValues } from "../../../../types";
import { GlobalContext } from "../../../../../../../../util/state/GlobalContextProvider";
import { IRangeDate } from "../../../../../../api/services";
import { editRangeDateValidity, editPendingBookingRce } from "../../../../recoil";
import { convertUtcToTzIsoDayJs } from "../../../../../../../../util/timezoneConversion";

const FormPickupDate = () => {
    const pickupLocationWatch = useWatch<IFormValues, 'basicDetails.pickupLocation'>({
        name: 'basicDetails.pickupLocation'
    });
    var timezone: string | undefined = pickupLocationWatch?.zoneId;

    const { t } = useTranslation('booking');

    const rangeDate = useRecoilValue<IRangeDate | undefined>(editRangeDateValidity);

    const isPendingBookingRce = useRecoilValue<boolean | undefined>(editPendingBookingRce);

    const { trigger, getValues } = useFormContext<IFormValues>();
    const { globalData } = useContext(GlobalContext);

    const currentDate = useMemo(() => convertUtcToTzIsoDayJs(dayjs().toISOString(), timezone) ?? undefined, [timezone]);

    const handleChange = useDebounceCallback(() => {
        trigger('basicDetails.pickupDate');
        if (getValues('basicDetails.dropoffDate')) {
            trigger('basicDetails.dropoffDate');
        }
    }, 300, []);
    const shouldDisableDate = useCallback((date: dayjs.Dayjs) => {
        const dmsAssociatedOperator = globalData.user.mobilityStores.map(
            ((elem:any) => {
                return elem.sapId;
            })
        );
        return shouldDisableRentalDate(date, getValues('basicDetails.pickupLocation'), RentalLocationType.Pickup, dmsAssociatedOperator, rangeDate);
    }, [rangeDate]);
    const shouldDisableTime = useCallback((time: number, clockTime: ClockPickerView) => {
        const dmsAssociatedOperator = globalData.user.mobilityStores.map(
            ((elem:any) => {
                return elem.sapId;
            })
        );
        return shouldDisableRentalTime(time, clockTime, RentalLocationType.Pickup, getValues('basicDetails.pickupLocation'), getValues('basicDetails.pickupDate'), dmsAssociatedOperator);
    }, []);

    const formContext = useFormContext<IFormValues>();

    useEffect(() => {
        timezone = pickupLocationWatch?.zoneId

        formContext.setValue(
            'basicDetails.pickupLocationTimezone',
            pickupLocationWatch?.zoneId ?? "Europe/Rome"
        );
    }, [pickupLocationWatch?.zoneId]);

    return (
        <FormDateTimePicker<IFormValues>
            name="basicDetails.pickupDate"
            label={t('label.pickupDate')}
            onChange={handleChange}
            minDateTime={currentDate}
            shouldDisableDate={shouldDisableDate}
            shouldDisableTime={shouldDisableTime}
            disabled={isPendingBookingRce}
        />
    );
};

export default FormPickupDate;

